import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export const integrationGridStyle = css`
  display: grid;
  width: 100%;
  max-width: ${spacing(310)};
  grid-template-columns: repeat(
    auto-fill,
    minmax(min(100%, ${spacing(75)}), 1fr)
  );
  flex-grow: 1;
  gap: ${spacing(5)};

  > * {
    width: 100%;
    max-width: ${spacing(100)};
  }
`

export const legacyMarketingStyle = css`
  margin-inline: ${spacing(10)};
  display: flex;
  flex-direction: column;
`

export const legacyMarketingTextStyle = css`
  ${getFontCss(
    16,
    themeConstants.colors.font_primary,
    styleConstants.fontFamilies.regular,
  )};
`
